import { createRouter, createWebHistory, RouteRecordRaw } from "vue-router";
// import { authGuard } from "../store";

const routes: Array<RouteRecordRaw> = [
  {
    path: "/login",
    name: "login",
    component: () => import("../views/LoginPage.vue"),
  },
  {
    path: "/home",
    name: "home",
    component: () => import("../views/home/HomePage.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/prospects",
    name: "prospects",
    component: () => import("../views/clients/ClientsPage.vue"),
    meta: { isClientPage: false, requiresAuth: true },
  },
  {
    path: "/clients",
    name: "clients",
    component: () => import("../views/clients/ClientsPage.vue"),
    meta: { isClientPage: true, requiresAuth: true },
  },
  {
    path: "/demands",
    name: "demands",
    component: () => import("../views/demands/DemandsPage.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/prospects/:id",
    name: "ProspectDetails",
    component: () => import("../views/prospects/ProspectDetails.vue"),
    // meta: { requiresAuth: true },
  },
  {
    path: "/:pathMatch(.*)*",
    redirect: "/home",
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

// Global navigation guard for authentication
router.beforeEach((to, from, next) => {
  const isAuthenticated = !!localStorage.getItem("token");
  if (to.meta.requiresAuth && !isAuthenticated) {
    next({ name: "login" });
  } else if (to.name === "login" && isAuthenticated) {
    next({ name: "home" });
  } else {
    next();
  }
});

export default router;
